import React from "react";
import "../components/styles/ServicesPage.css";
import newstoreels from "../assets/news-to-reels.png";
import smartclinic from "../assets/smart-clinic.png";
import slJudicial from "../assets/sl-judicialservices-academy.png";
import sshcBuilders from "../assets/sshc-builders.png";
import { FaArrowRight } from "react-icons/fa";
import { FaGlobe, FaInstagram, FaYoutube } from "react-icons/fa";

export default function ServicesPage() {
  return (
    <section className="page services-page">

      <h2>
        Our <span className="highlight">Services</span>
      </h2>

      <h3 className="sub-title">Building Apps With Purpose & Simplicity</h3>

      <p className="desc about-text">
        At <strong>Siara Marketing Pvt Ltd</strong>, we design and build mobile
        applications that are simple to use, visually clean, and optimized for
        smooth performance. Our focus is on creating technology-driven solutions
        that solve real-world problems and help businesses scale efficiently.
      </p>

      <h3 className="sub-heading">What We Offer</h3>

      <ul className="service-list about-list">
        <li>Custom Mobile App Development (iOS & Android)</li>
        <li>UI/UX Research & Interface Design</li>
        <li>Website Development</li>
        <li>API & Backend Development</li>
        <li>App Store & Play Store Publishing</li>
        <li>Bug Fixing & Code Cleanup</li>
        <li>Feature Upgrades & Enhancements</li>
        <li>App Performance Tuning</li>
        <li>Long-term Support & Maintenance</li>
      </ul>

      {/* Apps Section */}
      <h3 className="apps-heading">Checkout Our Apps</h3>

      <div className="apps-showcase">

        <div className="app-card fade-in">
          <div className="app-logo">
            <img src={smartclinic} alt="Smart Clinic" />
          </div>
          <h4>Smart Clinic</h4>
          <p>
            A healthcare app for booking doctor appointments, managing medical
            records, digital prescriptions, and receiving AI-based doctor
            recommendations based on patient symptoms.
          </p>
        </div>

        <div className="app-card fade-in">
          <div className="app-logo">
            <img src={newstoreels} alt="NewsToReels" />
          </div>
          <h4>NewsToReels</h4>
          <p>
            A social content platform where users share news, reels, chat with
            others, and explore trending stories in a short-video format.
          </p>
        </div>

      </div>

      {/* Other Businesses Section */}
      <h3 className="apps-heading">More From Our Group</h3>

      <div className="apps-showcase">

        <div className="app-card image-card fade-in">
          <div className="card-image">
            <img src={slJudicial} alt="SL Judicial Services Academy" />
          </div>

          <div className="card-content">
            <h4>SL Judicial Services Academy</h4>

            <p className="card-intro">
              Fast-paced, focused learning designed to prepare you for real-world
              judicial challenges through structured guidance and expert mentoring.
            </p>

            <div className="feature-list">
              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Live Classes</h5>
                  <p>Interactive, engaging sessions designed for focused learning.</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Curated Courses</h5>
                  <p>Carefully selected topics that matter most for your exam success.</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Integrated Learning</h5>
                  <p>Problem-solving driven preparation aligned with real exam scenarios.</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Interactive Sessions</h5>
                  <p>Group learning, activities, and challenges to sharpen your skills.</p>
                </div>
              </div>
            </div>
            <div className="card-actions">
              <a
                href="https://www.sljudicialservicesacademy.in/"
                target="_blank"
                rel="noreferrer"
                className="icon-btn website"
              >
                <FaGlobe />
                <span>Website</span>
                <FaArrowRight className="arrow-icon" />
              </a>

              <a
                href="https://www.instagram.com/sl_judicial_services_academy/"
                target="_blank"
                rel="noreferrer"
                className="icon-btn instagram"
              >
                <FaInstagram />
                <span>Instagram</span>
                <FaArrowRight className="arrow-icon" />
              </a>

              <a
                href="https://www.youtube.com/channel/UCpM-sGMv7PGTiOensp4c3SQ"
                target="_blank"
                rel="noreferrer"
                className="icon-btn youtube"
              >
                <FaYoutube />
                <span>YouTube</span>
                <FaArrowRight className="arrow-icon" />
              </a>
            </div>

          </div>

        </div>

        <div className="app-card image-card fade-in">
          <div className="card-image">
            <img src={sshcBuilders} alt="SSHC Builders" />
          </div>

          <div className="card-content">
            <h4>Sri Shanmukha Haranarayan Constructions</h4>

            <p className="card-intro">
              A reliable construction and real estate brand delivering thoughtfully
              designed residential and commercial spaces with quality and precision.
            </p>

            <div className="feature-list">
              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Quality Construction</h5>
                  <p>Strong foundations built with high-grade materials and standards.</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Modern Design</h5>
                  <p>Contemporary architecture that blends aesthetics and usability.</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Timely Delivery</h5>
                  <p>Projects executed efficiently with committed timelines.</p>
                </div>
              </div>

              <div className="feature-item">
                <span className="feature-no">*</span>
                <div>
                  <h5>Customer Trust</h5>
                  <p>Transparent process and long-term client satisfaction.</p>
                </div>
              </div>
            </div>

            <div className="card-actions">
              <a
                href="https://sshcbuilders.in/"
                target="_blank"
                rel="noreferrer"
                className="icon-btn website"
              >
                <FaGlobe />
                <span>Website</span>
                <FaArrowRight className="arrow-icon" />
              </a>

              <a
                href="https://www.instagram.com/sshcbuilders/"
                target="_blank"
                rel="noreferrer"
                className="icon-btn instagram"
              >
                <FaInstagram />
                <span>Instagram</span>
                <FaArrowRight className="arrow-icon" />
              </a>

              <a
                href="https://www.youtube.com/@SSHC_BUILDERS"
                target="_blank"
                rel="noreferrer"
                className="icon-btn youtube"
              >
                <FaYoutube />
                <span>YouTube</span>
                <FaArrowRight className="arrow-icon" />
              </a>
            </div>

          </div>

        </div>

      </div>

    </section>
  );
}
